<template>
  <div>
    <h1>Emails</h1>
    <div>
        
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
